/*
 * @Author: lisf
 * @Date: 2021-03-09 10:33:17
 * @LastEditors: lisf
 * @LastEditTime: 2021-04-26 10:58:22
 * @Description: 个人中心
 */
import request from '../../request'
import config from 'common/config'
const baseUrl = config.api.host

export default {
    login: data => {
        return request({
            url: baseUrl + `/openapi/public/login/loginByPassword`,
            method: 'post',
            params: data
        })
    },
    sendLoginSms: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/smslogin/sendLoginSms`,
            method: 'post',
            params: data
        })
    },
    smslogin: data => {
        return request({
            url: baseUrl + `/authservice/token`,
            method: 'post',
            params: data
        })
    },    
    checkUsername: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/smsfindpwd/checkoutUsername?username=${data.username}`,
            method: 'post',
            data: data
        })
    },
    sendUpdateSms: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/smsfindpwd/sendUpdateSms`,
            method: 'post',
            params: data
        })
    },
    smsfindpwdCheckCode: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/smsfindpwd/checkCode`,
            method: 'post',
            params: data
        })
    },
    updatePassword: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/smsfindpwd/updatePassword`,
            method: 'post',
            params: data
        })
    },
    smsRegister: data => {
        return request({
            url: baseUrl + `/ucwebservice/api/v1/uccall/smsRegister/register`,
            method: 'post',
            data
        })
    },
    sendRegisterSms: data => {
        return request({
            url: baseUrl + `/ucwebservice/api/v1/uccall/smsRegister/sendRegisterSms`,
            method: 'post',
            params: data
        })
    },
    smsRegisterRegister: data => {
        return request({
            url: baseUrl + `/ucwebservice/api/v1/uccall/smsRegister/register`,
            method: 'post',
            data
        })
    },
    checkExpire: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/qrcodeLogin/checkExpire`,
            method: 'get',
            params: data
        })
    },
    getToken: data => {
        return request({
            url: baseUrl + `/api/v1/uccall/qrcodeLogin/getToken`,
            method: 'get',
            params: data,
            unToast: true
        })
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/user/index.js